/**
 * @generated SignedSource<<17bf012fcfe1032887b44b6316851344>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RevokeUserAPIKeysInput = {
  identities: ReadonlyArray<string>;
  key: number;
};
export type RevokeUserApiKeysMutation$variables = {
  input: RevokeUserAPIKeysInput;
};
export type RevokeUserApiKeysMutation$data = {
  readonly revokeUserAPIKeys: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly revokedKeys: ReadonlyArray<{
      readonly id: string;
      readonly identity: string;
      readonly revokedAt: string | null | undefined;
    }> | null | undefined;
  };
};
export type RevokeUserApiKeysMutation = {
  response: RevokeUserApiKeysMutation$data;
  variables: RevokeUserApiKeysMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "APIKey",
  "kind": "LinkedField",
  "name": "revokedKeys",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "revokedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RevokeUserApiKeysMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RevokeAPIKeysPayload",
        "kind": "LinkedField",
        "name": "revokeUserAPIKeys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RevokeUserApiKeysMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RevokeAPIKeysPayload",
        "kind": "LinkedField",
        "name": "revokeUserAPIKeys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "765ca0143f5268143119d89eab57c7ff",
    "id": null,
    "metadata": {},
    "name": "RevokeUserApiKeysMutation",
    "operationKind": "mutation",
    "text": "mutation RevokeUserApiKeysMutation(\n  $input: RevokeUserAPIKeysInput!\n) {\n  revokeUserAPIKeys(input: $input) {\n    problems {\n      __typename\n      message\n    }\n    revokedKeys {\n      id\n      identity\n      revokedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "54b2f04d21d276e0138cc48946d0cb5d";

export default node;
